<template>
  <!-- Consistent empty/no-data placeholder. Used in tables (no-data slot)
       and on cards so every "nothing here yet" state looks the same. -->
  <div class="int-empty text-center" :class="dense ? 'py-6' : 'py-10'">
    <v-icon :size="dense ? 36 : 48" color="grey-lighten-1">{{ icon }}</v-icon>
    <div class="int-empty-title mt-2">{{ title }}</div>
    <div v-if="subtitle" class="int-empty-sub">{{ subtitle }}</div>
    <div v-if="$slots.action" class="mt-3">
      <slot name="action" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    icon: { type: String, default: 'mdi-inbox-outline' },
    title: { type: String, default: 'Nothing here yet' },
    subtitle: { type: String, default: '' },
    dense: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.int-empty-title {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--int-text);
}
.int-empty-sub {
  font-size: 0.82rem;
  color: var(--int-text-faint);
  margin-top: 2px;
}
</style>
